import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const ChevronDownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.59 8.99997L12 13.58L7.41 8.99997L6 10.41L12 16.41L18 10.41L16.59 8.99997Z"
          fill="black"
          fillOpacity="0.87"
        />
      </svg>
    )
  },
)
